import React, { ReactNode } from "react";
import { Box, CssBaseline, Typography } from "@mui/material";
import xlr8Logo from "../../assets/svgs/xlr8_logo_small.svg";
import { useAppTranslation } from "../../hooks/useAppTranslation";

interface AuthLayoutProps {
  children: ReactNode;
}

/**
 * Shared auth shell: brand panel on the left, form panel on the right.
 * Extracted from the sign in page so every auth screen (sign in, forgot
 * password) renders an identical layout, brand logo and copy.
 */
const AuthLayout: React.FC<AuthLayoutProps> = ({ children }) => {
  const { t } = useAppTranslation();

  return (
    <Box className="auth-screen">
      <CssBaseline />

      <div className="auth-brand">
        <div className="auth-brand-header">
          <img className="auth-brand-logo" src={xlr8Logo} alt="Velocity" />
          <span className="auth-brand-name">{t("auth.brand.name")}</span>
        </div>
        <div className="auth-brand-content">
          <Typography className="auth-brand-headline">
            {t("auth.brand.headlineLine1")} <br />
            {t("auth.brand.headlineLine2")}
          </Typography>
          <Typography className="auth-brand-subtext">
            {t("auth.brand.subtext")}
          </Typography>
        </div>
      </div>

      <div className="auth-form-panel">
        <div className="auth-form">
          <Box className="auth-form-logo">
            <img src={xlr8Logo} alt="" />
          </Box>
          {children}
          <div className="auth-form-footer">{t("auth.brand.footer")}</div>
        </div>
      </div>
    </Box>
  );
};

export default AuthLayout;
